(ns practitest.frontend.components.react-bootstrap
  (:require [reagent.core :as reagent]
            ["react-bootstrap/Popover" :as Popover]
            ["react-bootstrap/Tooltip" :as Tooltip]))

(def popover (reagent/adapt-react-class Popover))
(def tooltip (reagent/adapt-react-class Tooltip))
